/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Indoor_Cycling_TermsInputs */

const en_service_type_indoor_cycling_terms = /** @type {(inputs: Service_Type_Indoor_Cycling_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`spinning, spin class, indoor cycling`)
};

const pl_service_type_indoor_cycling_terms = /** @type {(inputs: Service_Type_Indoor_Cycling_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`spinning, indoor cycling, rowery stacjonarne`)
};

/**
* | output |
* | --- |
* | "spinning, spin class, indoor cycling" |
*
* @param {Service_Type_Indoor_Cycling_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_indoor_cycling_terms = /** @type {((inputs?: Service_Type_Indoor_Cycling_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Indoor_Cycling_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_indoor_cycling_terms(inputs)
	return en_service_type_indoor_cycling_terms(inputs)
});